import { makeStyles } from '@material-ui/core'

const styles = ({ clientPortalTheme }) =>
  makeStyles((theme) => ({
    root: {
      position: 'relative',
      background: theme.palette.primary.main,
      display: 'grid',
      width: '100%',
      minHeight: '100vh',
      overflow: 'auto',
      [theme.breakpoints.down('sm')]: {
        display: 'flex',
        flexDirection: 'column-reverse',
      },
      [theme.breakpoints.only('md')]: {
        gridTemplateColumns: '1fr 1fr',
      },
      [theme.breakpoints.up('lg')]: {
        gridTemplateColumns: '1fr 1fr',
      },
    },
    cardColumn: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: theme.spacing(5),
      zIndex: 1,
      [theme.breakpoints.down('sm')]: {
        flex: 1,
        alignItems: 'stretch',
        padding: theme.spacing(3),
      },
    },
    wrapper: {
      position: 'relative',
      zIndex: 1,
      width: '100%',
      maxWidth: 720,
      height: '100%',
      minHeight: 560,
      maxHeight: 880,
      overflowY: 'auto',
      background: theme.palette.white,
      borderRadius: theme.spacing(2),
      boxShadow: theme.shadows[3],
      [theme.breakpoints.down('sm')]: {
        maxWidth: 'none',
        minHeight: 600,
        borderRadius: theme.spacing(2),
      },
    },
    rightBanner: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'flex-start',
      paddingTop: '20vh',
      height: '100%',
      minHeight: 100,
      [theme.breakpoints.down('sm')]: {
        alignItems: 'center',
        paddingTop: 0,
        height: '15vh',
      },
    },
    dponetLogo: {
      position: 'relative',
      zIndex: 1,
      width: '80%',
      maxWidth: 520,
      height: 'auto',
      [theme.breakpoints.down('sm')]: {
        width: 'auto',
        maxWidth: 220,
      },
    },
    detailBottomRight: {
      position: 'fixed',
      bottom: 0,
      right: 0,
      zIndex: 0,
      ...(clientPortalTheme?.secondaryColor && {
        '& path': { stroke: `${clientPortalTheme.secondaryColor} !important` },
      }),
    },
    detailTopLeft: {
      position: 'fixed',
      top: 0,
      left: 0,
      transform: 'rotate(180deg)',
      zIndex: 0,
      ...(clientPortalTheme?.secondaryColor && {
        '& path': { stroke: `${clientPortalTheme.secondaryColor} !important` },
      }),
    },
  }))

export default styles
